module.exports = __webpack_public_path__ + "img/uniceflogo.cf348dec.png";